import axios from 'axios'
import Vue from 'vue'

var baseURL = 'https://api.dapenbi.co.id/'

var a = axios.create({
  baseURL: baseURL,
  headers: {
    'Accept': 'application/json'
  }
})

a.defaults.baseURL = baseURL

a.interceptors.response.use(null, function (error) {
  if (error.response.data.message === 'Token expired') {
    localStorage.removeItem('_token')
    localStorage.removeItem('username')
    localStorage.removeItem('namaLengkap')
    localStorage.removeItem('akses')
    Vue.router.push('/login')
    location.reload()
  }
  return Promise.reject(error)
})

export default a



// WEBPACK FOOTER //
// ./src/helper/api.js